import NotFoundIcon from "./icons/NotFoundIcon";

export default function NotFoundPage() {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-4 py-16">
      <NotFoundIcon />
      <h3>Page not found</h3>
    </div>
  );
}
